export default __webpack_public_path__ + "static/media/create-vehicle-group-icon.3b72a18b.svg";